/**
 * Formatta una dimensione in byte in stringa leggibile (B, KB, MB, GB, TB),
 * base 1024. Una cifra decimale sotto 10 (es. "1.5 MB"), intero sopra
 * (es. "240 KB"); niente ".0" superfluo. Stringa vuota per valori non validi
 * (NaN/negativi), così il chiamante può ometterla senza controlli extra.
 */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '';
  }

  if (bytes < 1024) {
    return `${bytes} B`;
  }

  const units = ['KB', 'MB', 'GB', 'TB'];

  let value = bytes / 1024;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  const rounded = value >= 10 ? Math.round(value) : Math.round(value * 10) / 10;

  return `${rounded} ${units[unitIndex]}`;
}
